import { render, staticRenderFns } from "./ModalEditCouncil.vue?vue&type=template&id=5769f792&"
import script from "./ModalEditCouncil.vue?vue&type=script&lang=ts&"
export * from "./ModalEditCouncil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports